import EfSection from '@elem/ui/ef-section';
import EfTab from '@elem/ui/ef-tab';
import { useState } from 'react';
import { useProductStore } from '@elem/compPage/12v-lithium-battery/ProductProvider';
import { PAGE_TYPE } from '../../constants';
import styles from './index.module.scss';
import ItemA from './ItemA';
import ItemB from './ItemB';
import ItemC from './ItemC';
import ItemD from './ItemD';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.TabA');
    const { pageType } = useProductStore();
    const itemsA = [
        {
            type: 'a',
            title: t('a_tab'),
        },
        {
            type: 'b',
            title: t('b_tab'),
        },
        {
            type: 'c',
            title: t('c_tab'),
        },
        {
            type: 'd',
            title: t('d_tab'),
        },
    ];
    if (pageType === PAGE_TYPE.BASE) {
        itemsA.splice(0, 1);
    }
    const dataA1: any = {
        a: <ItemA />,
        b: <ItemB />,
        c: <ItemC />,
        d: <ItemD />,
    };
    const currentData = pageType === PAGE_TYPE.MOTOR ? dataA1.a : dataA1.b;
    const [activeData, setActiveData] = useState(currentData);

    const callback = (item: any) => setActiveData(dataA1[item.type]);

    return (
        <div className={`${styles.TheComp} ${pageType === PAGE_TYPE.BASE ? 'white' : 'black'}`}>
            <EfSection theme={pageType === PAGE_TYPE.BASE ? 'black' : 'white'} label={t('label')} title={t('title')} desc={t('desc')} />
            {activeData}
            <EfTab
                theme={pageType === PAGE_TYPE.BASE ? 'white' : 'black'}
                activeType={pageType === PAGE_TYPE.MOTOR ? 'a' : 'b'}
                items={itemsA}
                onChange={callback}
            />
        </div>
    );
}
